// Utilidades compartidas por las sub-pestañas de "Carga de OTs". Estaban copiadas en cada
// componente; viven aquí para que formatos y lectura de propiedades sean uno solo.

// Lee una propiedad aceptando camelCase o PascalCase: el back serializa en PascalCase
// (Newtonsoft con la configuración por defecto), pero no se depende de eso.
export const prop = (obj, camel) => {
  if (!obj) return undefined
  if (obj[camel] !== undefined) return obj[camel]
  const pascal = camel.charAt(0).toUpperCase() + camel.slice(1)
  return obj[pascal]
}

export const num = (obj, camel) => {
  const v = Number(prop(obj, camel))
  return Number.isFinite(v) ? v : 0
}

export const fmtNum = (n) => Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 })

// Diferencia con signo: +N piezas de más, −N de menos.
export const fmtDif = (n) => {
  const v = Number(n || 0)
  if (v === 0) return '0'
  return `${v > 0 ? '+' : '−'}${fmtNum(Math.abs(v))}`
}

export const fmtFecha = (iso) => {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const p = (n) => String(n).padStart(2, '0')
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
}

// Formato del date-picker: "YYYY-MM-DD HH:mm".
export const fmtFiltro = (d) => {
  const p = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
}

// Convierte el valor del picker ("YYYY-MM-DD HH:mm" o "YYYY-MM-DD") a ISO para el query.
export const filtroAIso = (v) => {
  if (!v) return v
  const s = String(v).trim().replace(' ', 'T')
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s}T00:00:00`
  if (/T\d{2}:\d{2}$/.test(s)) return `${s}:00`
  return s
}

// Mensaje de error de una respuesta de axios, con un texto de respaldo.
export const mensajeError = (e, respaldo) => {
  const msg = e && e.response && e.response.data && e.response.data.message
  return msg || respaldo
}

// Alto de la tabla: solo se fija (y con encabezado pegado) cuando hay filas suficientes
// para que valga la pena; con pocas se deja crecer para no dejar un hueco vacío.
export const altoTabla = (filas) => (filas > 12 ? 480 : undefined)
